import RafflePage from './RafflePage';

const GiveawaySubsPage = () => {
  return (
    <RafflePage
      packageMode="subscription"
      entryPaymentPath="/giveaway-subs"
      openSubscriptionCheckoutInPage
    />
  );
};

export default GiveawaySubsPage;
